module.exports = __webpack_public_path__ + "img/conf_googlemeet.651e1813.png";